// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.summary, mat-expansion-panel {
  background-color: transparent;
}

.summary-table {
  font-size: 0.7em;
}

.summary-table tr td, .summary-table tr th {
  color: #808f94;
}

.summary-table tr th {
  border-bottom: 1px solid var(--theme-main-border-color, #055C8D) !important;
}

.summary-table tbody tr:hover {
  color: #808f94;
  background-color: #f3f3f3;
}

.summary-table tbody tr td {
  cursor: pointer;
  vertical-align: middle;
}

.summary-table tr th {
  vertical-align: middle;
}

h6 {
  font-weight: 500;
  font-size: 14px;
  line-height: 23px;
  color: #051344;
}

.no-data {
  font-size: 0.7em;
  color: #859296;
  text-align: center;
  height: 50px;
}

.medium-loader {
  border: 1px solid #f3f3f3;
  border-radius: 50%;
  border-top: 1px solid #3498db;
  width: 30px;
  height: 30px; /* Safari */
  animation: spin 2s linear infinite;
}

/* Safari */
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.show-loader {
  height: 50px;
  background-color: white;
}

.accordion-header-text {
  font-weight: 500;
  font-size: 14px;
  line-height: 23px;
  color: var(--theme-main-color, #055C8D);
  text-decoration: none !important;
}

.category-label {
  margin-left: 10px;
  margin-top: 10px;
}

.category-select {
  margin-left: 10px;
  margin-right: 10px;
  width: -webkit-calc(100% - 20px);
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
